import { useEffect, useState } from "react";
import { getCurrencies, updateCurrency } from "../../../../callApi/httpservice";
import CurrencySettingTable from "../../CurrencySettingTable";

function CurrencySetting() {
  const [items, setItems] = useState<any>(null);
  const [editCurrencyModal, setEditCurrencyModal] = useState<boolean>(false);
  const take: number = 10;
  const [offset, setOffset] = useState<number>(0);
  const [skip, setSkip] = useState<number>(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalItem, setTotalItem] = useState(0);
  const [itemEdit, setItemEdit] = useState<any>(null);
  const [newVariance, setNewVariance] = useState<string>("");
  const [newVarianceErr, setNewVarianceErr] = useState<string>("");
  const [newIndex, setNewIndex] = useState<string>("");
  const [newIndexErr, setNewIndexErr] = useState<string>("");
  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());
  const [dateMessageErr, setDateMessageErr] = useState<string>("");
  const [isWaitingSaving, setIsWaitingSaving] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [editIndexModal, setEditIndexModal] = useState<boolean>(false);
  const callApiGetCurrencies = async (take: number, skip: number) => {
    setItems(null);
    setIsFetching(true);
    const result: any = await getCurrencies({
      take,
      skip,
      sortDesc: true,
      sortBy: "createdAt",
    });
    if (result.status === 200) {
      setItems(result.data[0]);
      let count = result.data[1] as number;
      setTotalItem(count);
      if (count % take === 0) {
        setPageCount(count / take);
      } else {
        setPageCount(Math.floor(count / take) + 1);
      }
    }
    setIsFetching(false);
  };
  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    setOffset(selectedPage);
    setSkip(selectedPage * take);
  };
  const onSaveUpdatingVarianceClick = async () => {
    const checkValid = validate();
    if (checkValid) {
      setIsWaitingSaving(true);
      const body = {
        variance: +newVariance,
        varianceStartAt: new Date(startDate.setHours(0, 0, 0, 0)),
        varianceEndAt: new Date(endDate.setHours(23, 59, 59, 999)),
      };
      await updateCurrency(itemEdit.code, body);
      callApiGetCurrencies(take, skip);
      setNewVariance("");
      setEditCurrencyModal(false);
      setIsWaitingSaving(false);
    }
  };
  const validate = () => {
    setNewVarianceErr("");
    setDateMessageErr("");
    let msg: any = {};
    if (newVariance.trim() === "") {
      msg.newVariance = "New variance is required";
      setNewVarianceErr("New variance is required");
    }
    if (newVariance.trim() !== "") {
      if (+newVariance < 0) {
        msg.newVariance = "New variance is not less than zero";
        setNewVarianceErr("New variance is not less than zero");
      }
      if (+newVariance >= 100) {
        msg.newVariance = "New variance is not greater than or equal to 100";
        setNewVarianceErr("New variance is not greater than or equal to 100");
      }
    }
    if (new Date(endDate) <= new Date(startDate)) {
      msg.endDate = "This date is not valid";
      setDateMessageErr("This date is not valid");
    }

    if (Object.keys(msg).length > 0) return false;
    return true;
  };
  const onSaveUpdateIndexClick = async () => {
    const checkValid = validateIndex();
    if (checkValid) {
      setIsWaitingSaving(true);
      const body = {
        index: +newIndex,
      };
      await updateCurrency(itemEdit.code, body);
      callApiGetCurrencies(take, skip);
      setNewIndex("");
      setEditIndexModal(false);
      setIsWaitingSaving(false);
    }
  };
  const validateIndex = () => {
    setNewIndexErr("");
    let msg: any = {};
    if (newIndex.trim() === "") {
      msg.newIndex = "New index is required";
      setNewIndexErr("New index is required");
    }
    if (newIndex.trim() !== "") {
      if (+newIndex <= 0) {
        msg.newIndex = "New index is not less than or equal to zero";
        setNewIndexErr("New index is not less than or equal to zero");
      }
      if (+newIndex > totalItem) {
        msg.newIndex = "New index is not greater than total of item";
        setNewIndexErr("New index is not greater than total of item");
      }
      if (+newIndex % 1 !== 0) {
        msg.newIndex = "New index is not float type";
        setNewIndexErr("New index is not float type");
      }
    }
    if (Object.keys(msg).length > 0) return false;
    return true;
  };
  useEffect(() => {
    callApiGetCurrencies(take, skip);
  }, [offset]);
  return (
    <>
      <div className="bg-white xsm:p-1 xsm:pt-3 md:pt-5 xl:pt-10 md:p-5 xl:p-10 shadow-lg rounded-lg xsm:text-[12px] xs:text-[14px]">
        <CurrencySettingTable
          items={items}
          offset={offset}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          setItemEdit={setItemEdit}
          itemEdit={itemEdit}
          newVariance={newVariance}
          setNewVariance={setNewVariance}
          startDate={startDate}
          endDate={endDate}
          newVarianceErr={newVarianceErr}
          dateMessageErr={dateMessageErr}
          onSaveUpdatingVarianceClick={onSaveUpdatingVarianceClick}
          setEditCurrencyModal={setEditCurrencyModal}
          editCurrencyModal={editCurrencyModal}
          setItems={setItems}
          isWaitingSaving={isWaitingSaving}
          isFetching={isFetching}
          setEditIndexModal={setEditIndexModal}
          editIndexModal={editIndexModal}
          onSaveUpdateIndexClick={onSaveUpdateIndexClick}
          newIndex={newIndex}
          setNewIndex={setNewIndex}
          newIndexErr={newIndexErr}
          callApiGetCurrencies={callApiGetCurrencies}
          take={take}
          skip={skip}
        />
      </div>
    </>
  );
}

export default CurrencySetting;
